/**
 * @file certificates.ts
 * @description Виды документов производителя (сертификаты) и их подписи по-
 * русски — единый источник для api (страница группы сертификатов, SB141,
 * db-design-legal-docs §7), кабинета (карточка производителя, товар) и витрины
 * (phase19.16, ревью shared партии «Юридические документы»).
 *
 * Раньше подписи жили в двух копиях с расхождением: api
 * `legal/certificates-source.ts` (`SAFETY` → «Сертификат») и admin
 * `lib/catalog-format.ts` `CERT_LABELS` (`SAFETY` → «Сертификат безопасности»).
 * Взята точная подпись кабинета — она совпадает с комментарием enum
 * `CertificateType` в schema.prisma, а на витрине «Сертификат» без уточнения
 * ничего не говорит покупателю.
 */

import { deepFreeze } from "../site-theme/deep-freeze.js";

/** Виды документа производителя (= enum `CertificateType` Prisma). */
export const CERTIFICATE_TYPES = deepFreeze(["SGR", "TR_TS_DECLARATION", "SAFETY", "OTHER"] as const);
export type CertificateTypeKey = (typeof CERTIFICATE_TYPES)[number];

/** Подписи видов: кабинет (список, окно), витрина (страница группы сертификатов). */
export const CERTIFICATE_TYPE_LABELS: Readonly<Record<CertificateTypeKey, string>> = deepFreeze({
  SGR: "СГР",
  TR_TS_DECLARATION: "Декларация ТР ТС",
  SAFETY: "Сертификат безопасности",
  OTHER: "Другой документ",
});
